Position context. Required in applicant list context; may be omitted in candidate list context.
